// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import WatercolorController from "./watercolor_controller"
application.register("watercolor", WatercolorController)

import MatrixRainController from "./matrix_rain_controller"
application.register("matrix-rain", MatrixRainController)

import ChatWidgetController from "./chat_widget_controller"
application.register("chat-widget", ChatWidgetController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)
